import React from 'react';
import { Typography } from "antd";
import styled from "styled-components";

const { Text } = Typography;

// Styled Text with underline on hover
const StyledText = styled(Text)`
  color: rgba(0, 0, 0, 0.45);
  cursor: pointer;


  &:hover {
    text-decoration: underline;
    transition: transform 0.3s ease-in-out;
  }
`;


  interface MyComponentProps {
    text: string;
    onClick: () => void;
    style?: React.CSSProperties; // ✅ Allow inline styles
  }
  
  const SecondaryTextButton: React.FC<MyComponentProps> = ({ text, onClick, style }) => {
    return (
      <StyledText strong onClick={onClick} style={style}>
        {text}
      </StyledText>
    );
  };




export default SecondaryTextButton;